/**
 * Determines if a string has a numeric representation. It does not convert it!
 * @param value string
 * @returns true | false
 */
export default function isNumeric(value: string) {
  if (typeof value != 'string') return false; // we only process strings!
  return (
    !isNaN(value as unknown as number) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(value))
  ); // ...and ensure strings of whitespace fail
}
